import calcHeight from './calcHeight';
import FadeSlideshow from '../classes/FadeSlideshow';

function main(): void
{
	const historySlideshow = document.querySelector( 'div.history-slideshow' ) as HTMLElement;
	
	if ( !historySlideshow )
	{
		return;
	}
	
	new FadeSlideshow( historySlideshow );
	
	const slidesCollection = historySlideshow.querySelectorAll( 'ul.slides>li' ) as NodeListOf<HTMLElement>;
	
	if ( slidesCollection )
	{
		calcHeight( slidesCollection );
		window.addEventListener( 'resize', () => calcHeight( slidesCollection ) );
	}
}

export {
	main as default,
}
